<template>
<div>
  <label for="openSidebarMenu" class="sidebarIconToggle">
    <div class="spinner diagonal part-1"></div>
    <div class="spinner horizontal"></div>
    <div class="spinner diagonal part-2"></div>
  </label>
  <div id="sidebarMenu" :class="newsMenuOpened ? 'opened':''">
    <NewsTitle />
    <NewsSection />
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex';
import NewsTitle from 'NewsTitle';
import NewsSection from 'NewsSection';

export default {
  name: 'NewsSidebar',
  computed: mapState({
    newsMenuOpened: state => state.newsMenuOpened
  }),
  components: {
    NewsTitle,
    NewsSection
  },
  data() {
    return {
      privateFiles: process.env.VUE_APP_LOGIN === 'true',
      nameResolver: process.env.VUE_APP_NAME_RESOLVER === 'true',
      singleNight: process.env.VUE_APP_SINGLE_NIGHT === 'true',
      newsTitle: process.env.HAS_NEWS_TITLE === 'true',
      newsSection: process.env.HAS_NEWS_SECTION === 'true'
    };
  },
  created() {
    // add global reference to this component, so its methods can be used by other components
    this.$root.$refs.newsSidebar = this;
  },
  mounted() {
    document.addEventListener('click', this.closeSidebarMenuClickingOutside);
  },
  destroyed() {
    document.removeEventListener('click', this.closeSidebarMenuClickingOutside);
  },
  methods: {
    openModalByRef(ref) {
      this.hideOpenedModals();
      this.$refs[ref].show();
    },
    hideOpenedModals() {
      Object.values(this.$refs).forEach(r => {
        // TODO: find a way to check that this object is a modal
        if (typeof r.hide === 'function') {
          r.hide();
        }
      });
    },
    closeSidebarMenuClickingOutside(event) {
      if (!this.newsMenuOpened) {
        return;
      }
      if (isClickOnModal(event.target)) {
        // skip modal close event
        return;
      }
      let sidebarMenu = document.getElementById('sidebarMenu');
      if (event.clientX > sidebarMenu.getBoundingClientRect().width) {
        document.querySelector('.sidebarIconToggle').click();
      }
    }
  }
}

function isClickOnModal(node) {
  let css = node.getAttribute('class');
  if (css !== null && css.includes('fade')) { // modal fade
    return true;
  }
  while (node !== null && node.getAttribute) {
    css = node.getAttribute('class');
    if (css !== null && css.includes('modal-dialog')) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
}
</script>

<style>
#sidebarMenu {
  height: 100%;
  position: fixed;
  top: 56px;
  left: 0;
  width: 300px;
  transform: translateX(-300px);
  transition: transform 250ms ease-in-out;
  background-color: #fff;
  border-right: 1px #dfdfdf solid;
  padding-top: 10px;
  z-index: 500;
}

.sidebarMenuInner {
  margin: 0;
  padding: 0;
  border-top: 1px solid rgba(255, 255, 255, 0.10);
}

.sidebarMenuInner li {
  list-style: none;
  color: #222;
  padding: 3px;
  cursor: pointer;
  border-bottom: 1px solid rgba(255, 255, 255, 0.10);
}

.sidebarMenuInner>li {
  font-weight: bold;
  padding-left: 10px;
}

.sidebarMenuInner>li>ul>li {
  font-weight: normal !important;
  padding-left: 0px;
  list-style: circle;
}

.sidebarMenuInner li span {
  display: block;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.50);
}

.sidebarMenuInner li a {
  cursor: pointer;
}

.sidebarIconToggle {
  transition: all 0.3s;
  box-sizing: border-box;
  cursor: pointer;
  position: absolute;
  z-index: 99;
  height: 100%;
  width: 100%;
  top: 19px;
  left: 15px;
  height: 22px;
  width: 22px;
}

.sidebarIconToggle div {
  background-color: #555;
}

.sidebarSpinner {
  transition: all 0.3s;
  box-sizing: border-box;
  position: absolute;
  height: 3px;
  width: 100%;
  background-color: #fff;
}

.horizontal {
  transition: all 0.3s;
  box-sizing: border-box;
  position: relative;
  float: left;
  margin-top: 3px;
}

.diagonal.part-1 {
  position: relative;
  transition: all 0.3s;
  box-sizing: border-box;
  float: left;
}

.diagonal.part-2 {
  transition: all 0.3s;
  box-sizing: border-box;
  position: relative;
  float: left;
  margin-top: 3px;
}

#sidebarMenu.opened {
  transform: translateX(0);
}

#openSidebarMenu {
  transition: all 0.3s;
  box-sizing: border-box;
  display: none;
}

#openSidebarMenu:checked~.sidebarIconToggle>.horizontal {
  transition: all 0.3s;
  box-sizing: border-box;
  opacity: 0;
}

#openSidebarMenu:checked~.sidebarIconToggle>.diagonal.part-1 {
  transition: all 0.3s;
  box-sizing: border-box;
  transform: rotate(135deg);
  margin-top: 8px;
}

#openSidebarMenu:checked~.sidebarIconToggle>.diagonal.part-2 {
  transition: all 0.3s;
  box-sizing: border-box;
  transform: rotate(-135deg);
  margin-top: -9px;
}

#news-label {
  margin-left: 30px;
  margin-top: 4px;
}
</style>
